<template>
  <el-dialog title="提现详情" :visible.sync="dialogVisible" width="720px" :before-close="handleClose"  :close-on-click-modal="false">
    <div>
      <el-form label-width="130px">
        <div class='link-top'></div>
        <el-row>
          <el-col :span="8">
            <el-form-item label="提现金额：">
              <span style="font-weight: bold; font-size: 20px;"> {{$apecUtils.toFinancialNum(detailData.applyAmount, 2, '')}} 元</span>
            </el-form-item>
          </el-col>
          <div class='link-center'></div>
          <el-col :span="16">
            <el-form-item label="" >
              <span :class="detailData.auditStatus === '10' ? 'audit-status green' : detailData.auditStatus === '20' ? 'audit-status default' : 'audit-status red'">{{detailData.auditStatus | keyFilter("myAccount", "auditStatus")}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="提现账号：">
              {{detailData.exAccountNo.replace(/\s/g, '').replace(/(.{4})/g, "$1 ")}}
            </el-form-item>
            <el-form-item label="到账账号：">
              {{this.accountNo(detailData.bankCardNum, detailData.bankName)}}
            </el-form-item>
            <el-form-item label="申请时间：">
              {{detailData.applyTime}}
            </el-form-item>
            <el-form-item label="审核时间：">
              {{detailData.auditTime}}
            </el-form-item>
            <el-form-item label="支付时间：">
              {{detailData.tradeTime}}
            </el-form-item>
            <el-form-item label="备注：">
              {{detailData.tradeRemark}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import api from '@/api'
export default {
  name: 'withdrawal-detail',
  props: {
    detailData: {
      type: Object
    }
  },

  data () {
    return {
      detail: '',
      dialogData: {},
      dialogVisible: true,
      balance: ''
    }
  },
  created () {
    console.log(this.detailData)
  },
  methods: {
    // 查询平台账户实时金额
    async baseAccountBalance (baseAccountNo) {
      let data = (await api.myAccount.baseAccountBalance(JSON.stringify(this.detailData.baseAccountNo))).data
      this.$set(this.detailData, 'amount', data.amount)
      this.$set(this.detailData, 'withdrawableAmount', data.withdrawableAmount)
      this.$set(this.detailData, 'transferableAmount', data.transferableAmount)
      this.balance = data.amount - data.platformFreezeAmount
    },
    // 账号脱敏显示
    accountNo (val, bankName) {
      // let str = val.substring(2)
      return `${bankName} (${val.replace(/^([a-zA-Z0-9]{4})\d+(\d{4})$/, '$1 **** $2')})`
    },
    handleClose () {
      this.$emit('done')
    }
  },
}
</script>

<style lang="scss" scoped>
  ::v-deep .el-dialog__title {
    font-size: 16px;
    color: rgba(51,51,51,0.94);
    font-family: '微软雅黑';
    font-weight: bold;
  }
  ::v-deep .el-form-item__content {
    line-height: 41px;
  }
  ::v-deep .el-dialog__header {
    padding-bottom: 0px;
  }
  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
  ::v-deep .el-form-item__label {
    color: #999;
  }
  .gay {
    color: #999;
  }
  .link-top {
    width: 100%;
    height: 1px;
    border-top: solid #f8bd47 1px;
    margin-bottom: 15px;
  }
  .link-center {
    position: absolute;
    left: 0;
    top: 82px;
    width: 100%;
    height: 1px;
    border-top: solid #ccc 1px;
    margin-bottom: 15px;
  }
  .audit-status {
    display: inline-block;
    width: 80px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    margin-left: -133px;
  }
  .red {
    border: 1px solid red;
    color: red;
  }
  .green {
    border: 1px solid green;
    color: green;
  }
  .default {
    border: 1px solid #999;
    color: #999;
  }
</style>
